import React from 'react';
import { PersonalInfoCard } from './PersonalInfoCard';
import { EventDetailsCard } from './EventDetailsCard';
import { LocationCard } from './LocationCard';
import { PackagePaymentCard } from './PackagePaymentCard';
import { Contract } from '../../../types/contract';

interface InfoGridProps {
  contract: Contract;
}

export const InfoGrid: React.FC<InfoGridProps> = ({ contract }) => {
  return (
    <div className="space-y-2">
      {/* Grid de informações principais - responsivo */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <PersonalInfoCard contract={contract} />
        <EventDetailsCard contract={contract} />
        <LocationCard contract={contract} />
        <PackagePaymentCard contract={contract} />
      </div>
    </div>
  );
};
